import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function SellPage() {
  const steps = [
    { step: '1', title: 'List Your Tickets', desc: 'Set your price and upload details' },
    { step: '2', title: 'We Handle Everything', desc: 'Secure payment and delivery' },
    { step: '3', title: 'Get Paid Fast', desc: 'Receive funds within 24 hours' }
  ];

  return (
    <>
      <Helmet><title>Sell Tickets | BESTIX</title></Helmet>
      <div className="min-h-screen bg-gray-50">
        <div className="bg-navy py-16">
          <div className="container mx-auto px-4 text-center">
            <h1 className="font-playfair text-4xl font-bold !text-white">Sell Your Tickets</h1>
            <p className="mt-4 text-xl text-gray-300">List your tickets and reach premium buyers</p>
          </div>
        </div>
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-3xl mx-auto">
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              {steps.map((s, i) => (
                <div key={i} className="text-center">
                  <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl font-bold text-gold">{s.step}</span>
                  </div>
                  <h3 className="font-semibold text-navy mb-2">{s.title}</h3>
                  <p className="text-sm text-gray-600">{s.desc}</p>
                </div>
              ))}
            </div>
            <div className="text-center">
              <button className="btn btn-primary text-lg px-8 py-4">Start Selling</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
